import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const otherwise: SugarElementInfo = {
    name: "otherwise",
    availableChildren: { type: AvailableChildrenType.Any },
};
